<h2 mat-dialog-title>Confirm ${{refundAmount}} Refund</h2>
<mat-dialog-content class="mat-typography">
  <h4>Click continue to process ${{refundAmount}} for {{refundName}}</h4>
</mat-dialog-content>
<mat-dialog-actions align="end">
  <button class="btn btn-light btn-sm" 
        style="margin-right:10px;"
        [mat-dialog-close]="false" cdkFocusInitial>Cancel</button>
  <button class="btn btn-primary btn-sm ace-blue" 
          [mat-dialog-close]="true" cdkFocusInitial>Continue</button>
</mat-dialog-actions>
